import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  House,
  Scales,
  UserCircle,
  NewspaperClipping,
  Headset,
} from "@phosphor-icons/react";

const navItems = [
  {
    path: "/",
    label: "首頁",
    icon: <House size={26} />,
    isActive: (location) =>
      location.pathname === "/" ||
      (location.pathname.includes("/product") &&
        !location.pathname.includes("/my")) ||
      location.pathname.includes("/ecommerce"),
  },

  {
    path: "/community?category=recommend",
    label: "新聞",
    icon: <NewspaperClipping size={26} />,
    isActive: (location) => location.pathname.includes("/community"),
  },

  { path: "/consultant", label: "AI顧問", icon: <Headset size={26} /> },
  {
    path: "/regulation",
    label: "法規",
    icon: <Scales size={26} />,
    isActive: (location) => location.pathname.includes("/regulation"),
  },
  {
    path: "/my",
    label: "我的",
    icon: <UserCircle size={26} />,
    isActive: (location) =>
      location.pathname.includes("/my") ||
      location.pathname.includes("/profile-setting") ||
      location.pathname.includes("/apply-beautician") ||
      location.pathname.includes("/skin-markers") ||
      location.pathname.includes("/skin-analyze") ||
      location.pathname.includes("/customer-info"),
  },
];

const ACTIVE_COLOR = "#ACA561";
const INACTIVE_COLOR = "#343330";

const BottomNavigation = () => {
  const location = useLocation();

  const isNavItemActive = (path, isActiveFunc) => {
    return isActiveFunc ? isActiveFunc(location) : location.pathname === path;
  };

  const getNavItemStyles = (isActive) => ({
    textColor: isActive ? ACTIVE_COLOR : INACTIVE_COLOR,
  });

  return (
    <div className="fixed bottom-0 z-30 mx-auto flex w-full justify-around bg-white px-1 py-2 shadow-up">
      {navItems.map(({ path, label, icon, isActive }) => {
        const active = isNavItemActive(path, isActive);
        const { textColor } = getNavItemStyles(active);

        return (
          <Link key={path} to={path}>
            <div
              className={`flex flex-col items-center gap-0.5`}
              style={{ color: textColor }}
            >
              {icon}
              <span className={`!text-[10px] text-xs`}>{label}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default BottomNavigation;
